import React from "react";
import { FaAward } from "react-icons/fa6";
import { VscFolderActive } from "react-icons/vsc";

function About() {
  return (
    <section id="about">
      <div className="about container">
        <div className="top_section">
          <h5>Get To Know</h5>
          <h2>About me</h2>
        </div>
        <div className="about-container">
          <div className="about-content">
            <p>
              <h1>
                I'm <span>Zakaria Hizzi</span>, a Web developer
              </h1>
              I'm a front-end web developer with a strong passion for creating
              visually appealing and user-friendly web applications. I am very
              passionate about improving my coding skills & developing
              applications & websites.
            </p>
            <div className="about-card">
              <FaAward className="about-icons" />
              <h5>Experience</h5>
              <small>3+ years working</small>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
